import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ spacing, palette, direction }) => ({
		root: {
			justifyContent: 'flex-start',
		},
		button: {
			width: '100%',
			height: '100%',
			maxWidth: '100%',
			minHeight: spacing(6),
		},
		addButton: {
			fontFamily: 'Instrument Sans',
			background: 'none !important',
			color: palette.calcContrastColor(palette.scoreapp.primary, palette.background.default),
			minHeight: spacing(6),
			fontSize: spacing(2),
			letterSpacing: 'normal',
			textDecoration: 'none',
			textTransform: 'none',
			lineHeight: 1.5,
			fontStyle: 'normal',
			fontWeight: 400,
		},
		icon: {
			marginRight: direction === 'rtl' ? 0 : null,
			marginLeft: direction === 'rtl' ? spacing(1) : null,
		},
	}),
	{ name: 'Questions-AnswerTypes-MultipleChoiceButtons-OptionList' },
)

export default useStyles
